module.exports = __webpack_public_path__ + "img/Boomhut.b948488d.svg";